var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',{staticClass:"nav-item ml-2"},[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" "+_vm._s(_vm.t('Sidebar.Menu'))+" ")])]),_vm._l((_vm.items),function(item){return _c(_vm.resolveNavItemComponent(item),{key:item.header || item.title,tag:"component",attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }